<svg width="20" height="7" stroke="white" fill="white" viewBox="0 0 120 30" xmlns="http://www.w3.org/2000/svg">
  <circle class="circle" cx="15" cy="15" r="15" />
  <circle class="circle1" cx="60" cy="15" r="9" fill-opacity="0.9" />
  <circle class="circle2" cx="105" cy="15" r="15" />
</svg>

<style>
  @keyframes spinner-animation {
    0% {
      r: 15;
      fill-opacity: 1;
    }

    100% {
      r: 9;
      fill-opacity: 0.5;
    }
  }
  .circle {
    animation: spinner-animation 0.45s alternate infinite ease-in-out;
  }
  .circle1 {
    animation: spinner-animation 0.45s 0.15s alternate infinite ease-in-out;
  }
  .circle2 {
    animation: spinner-animation 0.45s 0.3s alternate infinite ease-in-out;
  }
</style>
